class StaticResourcePreloader
	@$inject: [
		'$q'
		'MasterUserRepository'
		'UserRepository'
		'ConfigurationRepository'
		'AuthenticationRepository'
		'PublicRepository'
	]
	@resources: {}

	constructor: ->
		DI = StaticResourcePreloader.getInjector()

		for service in StaticResourcePreloader.$inject
			@[service] = DI.get service

	@getInjector: ->
		return angular.injector([
			'ng'
			'App.Service'
			'App.Repository'
			'App.Constant.Configuration'
			'App.Constant.Common'
			'LocalStorageModule'
		])

	loadConfigurations: ->
		@ConfigurationRepository.getEntities()

	loadMasterUser: (id) ->
		query = @MasterUserRepository.createQuery()
		query.with 'distributor'

		return @MasterUserRepository.getEntity(id, query)

	loadResourceToken: () ->
		return @AuthenticationRepository.getResourceToken()

	loadSubUser: (id) ->
		return null if _.isEmpty(id)

		query = @UserRepository.createQuery()
		query.with 'shops'

		return @UserRepository.getEntity id, query

	loadLanguages: ->
		return @PublicRepository.getTranslatedLanguages()

	loadResources: (masterUserId, subUserId = null) ->
		promises =
			master_user: @loadMasterUser(masterUserId)
			sub_user: @loadSubUser(subUserId)
			configs: @loadConfigurations()
			resource_token: @loadResourceToken()
			languages: @loadLanguages()

		return @$q
			.all(promises)
			.then (responses) =>
				StaticResourcePreloader.resources = responses
